import { gql } from 'apollo-angular';

const GET_RECENTLY_ADDED_ORGANIZATIONS = gql`
  query recentlyAddedOrganizations {
    recentlyAddedOrganizations {
      id
      name
      organizationType
    }
  }
`;

export default GET_RECENTLY_ADDED_ORGANIZATIONS;
